import moment from 'moment';

export const allPositions = [
  "S1",
  "S2",
  "S3/AM",
  "M1",
  "M2",
  "M3",
  "SM1",
  "SM2",
  "SM3",
  "Director",
  "Partner",
  "Other",
]

export const allLocations = [
  'Singapore',
  'Hong Kong',
  // 'China',
  // 'UK',
];

export const allCurrencys = [
  'GBP',
  'SGD',
  'HKD',
  // 'RMB',
];

export const getCurrencyFullName = (currency) => {
  switch(currency) {
    case 'GBP':
      return 'Great British Pounds';
    case 'SGD':
      return 'Singapore Dollars';
    case 'HKD':
      return 'Hong Kong Dollar';
    // case 'RMB':
    //   return 'Chinese Yuan';
    default:
      return '';
  }
}

export const getCurrencySign = (currency) => {
  switch(currency) {
    case 'GBP':
      return '£';
    case 'SGD':
      return 'S$';
    case 'HKD':
      return 'HK$';
    // case 'RMB':
    //   return '¥';
    default:
      return '';
  }
};

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    }
  });
}

const bankBasicDetail = {
  name: 'National Westminster Bank (NatWest)',
  address: '19 School Road, Sale, Cheshire, UK, M33 7ZA',
}

const sgdBankDetail = {
  ...bankBasicDetail,
  ...{
    sortCode: '01-07-71',
    account: '55015638',
    iban: 'GB73NWBK60730155015638',
    bic: 'NWBKGB2L',
  }
}

const gbpBankDetail = {
  ...bankBasicDetail,
  ...{
    sortCode: '01-07-71',
    account: '59413425',
    iban: 'GB53NWBK01077159413425',
    bic: 'NWBKGB2L',
  }
}

// const rmbBankDetail = {
//   ...bankBasicDetail,
//   ...{
//     sortCode: 'RMB-SORT-CODE',
//     account: 'RMB-ACCOUNT',
//     iban: 'RMB-IBAN',
//     bic: 'RMB-BIC',
//   }
// }

const hkdBankDetail = {
  ...bankBasicDetail,
  ...{
    sortCode: '01-07-71',
    account: '55015700',
    iban: 'GB48NWBK60730155015700',
    bic: 'NWBKGB2L',
  }
}

const getBankDetail = (currency) => {
  switch(currency) {
    case 'GBP':
      return gbpBankDetail;
    case 'SGD':
      return sgdBankDetail;
    case 'HKD':
      return hkdBankDetail;
    // case 'RMB':
    //   return rmbBankDetail;
    default:
      return null;
  }
}

export const buildInvoicePDFTemplate = async (invoice, create=true, noName=false) => {
  const isInt = (n) => {
    return Number(n) === n && n % 1 === 0;
  }

  const buildFee = (n) => {
    if (isInt(n)) {
      return `${n.toLocaleString()}.00`;
    }
    return `${n.toLocaleString()}`;
  }

  const showAdditionalContact = () => {
    if (additionalContact) {
      return {text: `${additionalContact.firstname} ${additionalContact.lastname}`, listType: 'none', margin: [28, 0, 0, 0]}
    }
    return {}
  }

  let fee;
  let currency;
  let reference;
  let candidate;
  let client;
  let contact;
  let additionalContact;
  let paymentTerm;

  if (create) {
    fee = buildFee(invoice.invoice.fee);
    currency = invoice.invoice.currency;
    reference = invoice.invoice.reference;
    candidate = invoice.candidate;
    client = invoice.client;
    contact = invoice.contact;
    additionalContact = invoice.additionalContact;
    paymentTerm = invoice.invoice.paymentTerm;
  } else {
    fee = buildFee(invoice.fee);
    currency = invoice.currency;
    reference = invoice.reference;
    candidate = invoice.candidate_docs;
    client = invoice.client_docs;
    contact = invoice.contact_docs;
    additionalContact = invoice.additionalContact_docs;
    paymentTerm = invoice.paymentTerm;
  }

  const bank = getBankDetail(currency);

  const largeSize = 15;
  const defaultSize = 12;
  const smallSize =11;
  const space = [3, 3, 3, 3];

  const Linelayout = {
    hLineWidth: function(i, node) {
      return (i === 0 || i === node.table.body.length) ? 0 : 1;
    },
    vLineWidth: function(i, node) {
      return 0;
    }
  }

  const imageURL = 'https://link-global-public.s3.eu-west-1.amazonaws.com/Link-Global.jpg';
  const image = await getBase64FromUrl(imageURL);
  const content = [];

  content.push({
    table: {
      widths: [335, 335],
      body: [
        [
          {text: 'Invoice', bold: true, fontSize: 28}, 
          {
            image: image,
            width: 170,
            height: 30,
          },
        ]
      ]
    },
    layout: Linelayout,
  });

  content.push(
    {
      text: '\n',
    },
  );

  content.push({
    table: {
      widths: [335, 300],
      body: [
        [
          {
            table: {
              widths: [300, 200],
              body: [
                [
                  {ul: [
                    {text: client.invoiceClientName, listType: 'none', margin: [0, 0, 0, 10]},
                    {text: client.invoiceAddress.address1, listType: 'none'},
                    {text: client.invoiceAddress.address2, listType: 'none'},
                    {text: client.invoiceAddress.city, listType: 'none'},
                    {text: client.invoiceAddress.country, listType: 'none'},
                    {text: client.invoiceAddress.postcode, listType: 'none', margin: [0, 0, 0, 15]},
                  ],
                  margin: [-15, 10, 0, 10],
                  }, 
                ]
              ]
            },
            layout: Linelayout,
          },
          {
            table: {
              widths: [300, 200],
              body: [
                [
                  {ul: [
                    {text: [`Invoice Reference: `, {text: reference, bold: true}], listType: 'none'},
                    {text: `Invoice Date: ${create ? moment().format('YYYY-MM-DD') : moment(invoice.sendInvoiceDate).format('YYYY-MM-DD')}`, listType: 'none', margin: [0, 0, 0, 10]},
                    {text: `Attn: ${contact.firstname} ${contact.lastname}`, listType: 'none'},
                    showAdditionalContact(),
                  ],
                  margin: [-15, 10, 0, 10],
                  }, 
                ]
              ]
            },
            layout: Linelayout,
          }
        ]
      ]
    },
    layout: Linelayout,
  });

  let descText;
  if (noName) {
    descText = `Professional fees in connection with recruitment`;
  } else {
    descText = `Professional fees in connection with the recruitment of ${candidate.firstname} ${candidate.lastname}`;
  }

  content.push({
    table: {
      widths: ['*', 95],
      body: [
        [
          {text: 'Description', margin: space, fillColor: '#ddd',},
          {text: 'Amount', alignment: 'right', margin: space, fillColor: '#ddd'},
        ],
        [
          {text: descText, margin: space,},
          {text: `${getCurrencySign(currency)} ${fee}`,  alignment: 'right', margin: space}
        ]
      ]
    },
    margin: [5, 0, 0, 0],
  });

  content.push(
    {text: `* Please note that this invoice is in ${getCurrencyFullName(currency)}`, margin: [5, 10, 0, 0], italics: true, bold: true},
  );

  content.push(
    {
      text: '\n\n',
    },
  );

  content.push({
    table: {
      widths: [300, 335],
      body: [
        [
          {
            table: {
              widths: [400],
              body: [
                [
                  {ul: [
                    {text: `PAYMENT TERMS - ${paymentTerm} DAYS`, listType: 'none', bold: true, fontSize: largeSize},
                    {text: 'If you wish to pay by BACS our bank details are', listType: 'none', margin: [0, 0, 0, 5]},
                    {text: bank.name, listType: 'none', bold: true, fontSize: smallSize},
                    {text: bank.address, listType: 'none', bold: true, fontSize: smallSize},
                    {text: '\n', listType: 'none'},
                    {text: `Sort Code: ${bank.sortCode}`, listType: 'none', bold: true, fontSize: smallSize},
                    {text: `Account: ${bank.account}`, listType: 'none', bold: true, fontSize: smallSize},
                    {text: `IBAN: ${bank.iban}`, listType: 'none', bold: true, fontSize: smallSize},
                    {text: `BIC: ${bank.bic}`, listType: 'none', bold: true, fontSize: smallSize},
                  ],
                  margin: [-15, 10, 0, 10],
                  }, 
                ]
              ]
            },
            layout: Linelayout,
          },
          {
            table: {
              widths: [400],
              body: [
                [{
                  table: {
                    widths: [95,95],
                    body: [
                      [
                        {text: 'Net', margin: space, fillColor: '#eee'},
                        {text: `${getCurrencySign(currency)} ${fee}`, alignment: 'right', margin: space},
                      ],
                      [
                        {text: `VAT 0.00%`, margin: space, fillColor: '#eee'},
                        {text: `0.00`, alignment: 'right', margin: space}
                      ],
                      [
                        {text: `Total`, margin: space, fillColor: '#eee'},
                        {text: `${getCurrencySign(currency)} ${fee}`, alignment: 'right', margin: space, bold: true}
                      ]
                    ],
                  },
                }]
              ]
            },
            margin: [-10, 30, 0, 0],
            layout: Linelayout,
          }
        ]
      ]
    },
    layout: Linelayout,
  });
  
  return {
    pageSize: 'A4',
    defaultStyle: {
      fontSize: defaultSize,
    },
    content,
    footer: function (currentPage, pageCount) {
      return { 
        ul: [
          {text: 'Link Global Recruitment Ltd', listType: 'none'},
          {text: '61 Bridge Street, Kington', listType: 'none'},
          {text: 'United Kingdom, HR5 3DJ', listType: 'none'},
          {text: 'Company number: 13882564', listType: 'none'},
          {text: 'Email: finance@linkglobalrecruitment.com', listType: 'none'},
        ],
        alignment: 'right', 
        fontSize: 8, 
        margin: [0, -20, 15, 0],
        width: '*',
      };
    },
  }
}